import * as React from 'react';
import Chart from 'react-apexcharts';
const HistoricDebtApexChart = ({ data, i18n }) => {
    const totalNumberOfJudgments = data.map(x => ([
        new Date(x.date).getTime(), x.debt.numberOfAJudgments + x.debt.numberOfEJudgments
    ]));
    const totalDebtSum = data.map(x => ([
        new Date(x.date).getTime(), x.debt.totalAEJudgements
    ]));
    const endDate = new Date().getTime();
    const oldestDebt = new Date(data[data.length - 1].date).getTime();
    const startDate = Math.min(oldestDebt, new Date(endDate).setMonth(new Date(endDate).getMonth() - 12));
    const totalDebtSumOption = {
        series: [{
                name: i18n('common.graph.totalSum'),
                data: totalDebtSum
            }],
        options: {
            title: {
                text: i18n('common.graph.totalSum')
            },
            chart: {
                group: 'historicDebt',
                toolbar: {
                    show: false
                },
                id: 'totalDebtSum',
                type: 'area',
                height: 350,
                zoom: {
                    enabled: false
                }
            },
            colors: ['#f997cb'],
            dataLabels: {
                enabled: false
            },
            markers: {
                size: [4, 7],
            },
            xaxis: {
                type: 'datetime',
                min: startDate,
                max: endDate,
                tickAmount: 6,
            },
            yaxis: {
                min: 0,
                labels: {
                    minWidth: 40
                },
                forceNiceScale: true
            },
            tooltip: {
                x: {
                    show: false
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 100]
                }
            },
        },
    };
    const totalNumberOfJudgmentsOption = {
        series: [{
                name: i18n('common.graph.numberOfJudgments'),
                data: totalNumberOfJudgments
            }],
        options: {
            title: {
                text: i18n('common.graph.numberOfJudgments')
            },
            chart: {
                group: 'historicDebt',
                toolbar: {
                    show: false
                },
                id: 'totalNumberOfJudgments',
                type: 'area',
                height: 350,
                zoom: {
                    enabled: false
                }
            },
            colors: ['#009B48'],
            dataLabels: {
                enabled: false
            },
            markers: {
                size: [4, 7],
            },
            xaxis: {
                type: 'datetime',
                min: startDate,
                max: endDate,
                tickAmount: 6,
            },
            yaxis: {
                min: 0,
                labels: {
                    minWidth: 40,
                    formatter: function (val) {
                        return val.toFixed(0);
                    }
                },
                forceNiceScale: true
            },
            tooltip: {
                x: {
                    show: false
                }
            },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.7,
                    opacityTo: 0.9,
                    stops: [0, 100]
                }
            },
        },
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(Chart, { options: totalDebtSumOption.options, series: totalDebtSumOption.series, type: "area", height: 250 }),
        React.createElement(Chart, { options: totalNumberOfJudgmentsOption.options, series: totalNumberOfJudgmentsOption.series, type: "area", height: 250 })));
};
export default HistoricDebtApexChart;
